import { slider, spFlowSlider, spSlider } from './modules/slider';
slider();
spSlider();
spFlowSlider();
